import React from 'react';
import { css } from '@emotion/css';

const policyPage = css({
  width: '100%',
  maxWidth: '1200px',
  margin: '0 auto',
  padding: 'var(--spacing-lg)',
  minHeight: 'calc(100vh - 100px)',
});

const policyPageContainer = css({
  display: 'flex',
  flexDirection: 'column',
  gap: 'var(--spacing-lg)',
});

const policyPageHeader = css({
  marginBottom: 'var(--spacing-lg)',
  borderBottom: '2px solid var(--pc-200)',
  paddingBottom: 'var(--spacing-md)',
});

const policyPageTitle = css({
  fontSize: 'var(--fs-800)',
  fontWeight: 700,
  color: 'var(--pc-700)',
  marginBottom: 'var(--spacing-xs)',
});

const policyPageContent = css({
  fontSize: 'var(--fs-400)',
  lineHeight: 1.6,
  color: 'var(--g-800)',
});

const policyPageSection = css({
  marginBottom: 'var(--spacing-lg)',
});

const policyPageSectionTitle = css({
  fontSize: 'var(--fs-600)',
  fontWeight: 600,
  color: 'var(--pc-600)',
  marginBottom: 'var(--spacing-sm)',
  paddingBottom: 'var(--spacing-xs)',
  borderBottom: '1px solid var(--pc-100)',
});

const policyPageParagraph = css({
  marginBottom: 'var(--spacing-md)',
});

const policyPageDate = css({
  fontStyle: 'italic',
  marginTop: 'var(--spacing-lg)',
  color: 'var(--g-600)',
  fontSize: 'var(--fs-350)',
});

// Media queries for responsiveness
const responsiveStyles = css({
  '@media (max-width: 768px)': {
    [`&.${policyPage}`]: {
      padding: 'var(--spacing-md)',
    },
    [`.${policyPageTitle}`]: {
      fontSize: 'var(--fs-700)',
    },
    [`.${policyPageSectionTitle}`]: {
      fontSize: 'var(--fs-500)',
    },
  },
  '@media (max-width: 480px)': {
    [`&.${policyPage}`]: {
      padding: 'var(--spacing-sm)',
    },
    [`.${policyPageTitle}`]: {
      fontSize: 'var(--fs-600)',
    },
    [`.${policyPageContent}`]: {
      fontSize: 'var(--fs-350)',
    },
    [`.${policyPageSectionTitle}`]: {
      fontSize: 'var(--fs-450)',
    },
  },
});

export const RefundPolicy: React.FC = () => {
  return (
    <div className={`${policyPage} ${responsiveStyles}`}>
      <div className={policyPageContainer}>
        <div className={policyPageHeader}>
          <h1 className={policyPageTitle}>Políticas de Reembolso</h1>
        </div>

        <div className={policyPageContent}>
          <div className={policyPageSection}>
            <h3 className={policyPageSectionTitle}>1. Prazos para solicitação de reembolso</h3>
            <p className={policyPageParagraph}>
              <strong>1.1.</strong> Em caso de cancelamento de pedidos, o reembolso do valor do ingresso, 
              descontada a taxa de serviço, somente será efetuado caso a solicitação seja feita no prazo de 
              até 7 (sete) dias a contar da data da compra (como garante o Código de Defesa do Consumidor).
            </p>
          </div>

          <div className={policyPageSection}>
            <h3 className={policyPageSectionTitle}>2. Reembolso em casos específicos</h3>
            <p className={policyPageParagraph}>
              <strong>2.1.</strong> Caso o cliente solicite o cancelamento, o reembolso apenas será efetuado 
              se esta solicitação for feita num prazo mínimo de 48 (quarenta e oito) horas de antecedência do 
              horário de início do evento.
            </p>
            <p className={policyPageParagraph}>
              <strong>2.2.</strong> Em caso de cancelamento, adiamento ou alteração significativa no evento 
              por parte da produtora, os compradores dos ingressos para o respectivo evento serão notificados, 
              sendo oferecida a possibilidade de atribuir o ingresso a uma nova edição ou a opção de reembolso.
            </p>
          </div>

          <div className={policyPageSection}>
            <h3 className={policyPageSectionTitle}>3. Como solicitar o reembolso</h3>
            <p className={policyPageParagraph}>
              <strong>3.1.</strong> Para solicitar o reembolso, entre em contato diretamente conosco, através 
              de algum canal do fale conosco, informando o evento que deseja solicitar o ressarcimento.
            </p>
          </div>

          <div className={policyPageSection}>
            <h3 className={policyPageSectionTitle}>4. Processamento do reembolso</h3>
            <p className={policyPageParagraph}>
              <strong>4.1.</strong> A restituição do valor, ao ser cancelado, é feita de acordo com a forma 
              de compra (cartão de crédito, Pix, etc.).
            </p>
            <p className={policyPageParagraph}>
              <strong>4.2.</strong> O prazo para o estorno ser efetivado depende da forma de pagamento utilizada 
              e as políticas do banco ou da operadora do cartão de crédito.
            </p>
          </div>

          <p className={policyPageDate}>
            Esta política é válida e vigente a partir de 09 de janeiro de 2026.
          </p>
        </div>
      </div>
    </div>
  );
};

export default RefundPolicy;
